import React from 'react';

const SplashScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-pink-500 flex flex-col items-center justify-center p-4">
      <div className="w-80 h-80 mb-8">
        <img
          src="/logo_animation_pinkinverse.gif"
          alt="Logo Animation"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
};

export default SplashScreen; 